import { Card as HygraphCardProps } from '@/lib/types';

import { CardProps } from '@/components/card';

import { Side } from '@/enums/side';
import { VerticalSide } from '@/enums/vertical-side';
import cardStyleTransformer from '@/hygraph/transformers/card-style.transformer';
import horizontalAlignmentTransformer from '@/hygraph/transformers/horizontal-alignment.transformer';
import hygraphImageTransformer from '@/hygraph/transformers/hygraph-image.transformer';
import imageWidthTransformer from '@/hygraph/transformers/image-width.transformer';
import linkTransformer from '@/hygraph/transformers/link.transformer';
import richTextTransformer from '@/hygraph/transformers/rich-text.transformer';
import verticalSideTransformer from '@/hygraph/transformers/vertical-side.transformer';

export default function cardTransformer(
  props: HygraphCardProps & { isInSidebar?: boolean }
): CardProps {
  return {
    caption: props.caption || undefined,
    title: props.title || undefined,
    body: richTextTransformer({
      content: props.body?.raw,
    }),
    image: props.image ? hygraphImageTransformer(props.image) : undefined,
    imagePosition: cardImagePositionTransformer(props),
    imageWidth: imageWidthTransformer(props.imageWidth),
    cardStyle: props.cardStyle && cardStyleTransformer(props.cardStyle),
    link: linkTransformer(props.link),
    linkDecorator: props.linkDecorator ? props.linkDecorator : false,
    textAlignment: horizontalAlignmentTransformer(props.textAlignment),
    isInSidebar: props.isInSidebar,
  };
}

function cardImagePositionTransformer(
  props: HygraphCardProps
): CardProps['imagePosition'] {
  const position = verticalSideTransformer(props.imageVerticalSide);
  const isWide = props.cardStyle?.startsWith('Wide');
  if (isWide) {
    if (position === VerticalSide.BOTTOM) {
      return Side.RIGHT;
    }

    return Side.LEFT;
  }

  return position;
}
